export function parseCardExpiry(value) {
  const match = String(value)
    .trim()
    .match(/^(\d{1,2})\s*\/\s*(\d{2,4})$/);
  if (!match) return null;

  const month = parseInt(match[1], 10);
  let year = parseInt(match[2], 10);
  if (year < 100) year += 2000;

  if (month < 1 || month > 12) return null;

  return { month, year };
}

export function formatCardExpiry(
  value,
  { expandYear = false, shortenYear = false } = {}
) {
  const stringValue = String(value);
  const slashIndex = stringValue.indexOf('/');
  const monthDigitsBeforeSlash =
    slashIndex === -1
      ? null
      : stringValue.slice(0, slashIndex).replace(/\D/g, '');
  const shouldPadMonth = monthDigitsBeforeSlash?.length === 1;
  const digits = stringValue
    .replace(/\D/g, '')
    .slice(0, shouldPadMonth ? 5 : 6);
  if (shouldPadMonth && digits.length === 1) return `0${digits}/`;
  if (digits.length < 2) return digits;

  const month = shouldPadMonth ? `0${digits[0]}` : digits.slice(0, 2);
  let year = digits.slice(shouldPadMonth ? 1 : 2);

  if (shortenYear && year.length > 2) {
    year = year.slice(-2);
  }

  if (expandYear && year.length === 2) {
    year = `20${year}`;
  }

  return `${month}/${year}`;
}

export function isCardExpiryValid(value) {
  const parsed = parseCardExpiry(value);
  if (!parsed) return false;

  const now = new Date();
  const expYYYYMM = parsed.year * 100 + parsed.month;
  const nowYYYYMM = now.getFullYear() * 100 + (now.getMonth() + 1);

  return expYYYYMM >= nowYYYYMM;
}

export function initCardExpiryInput(
  input,
  { expandYearOnBlur = false, placeholder = 'MM/YY' } = {}
) {
  if (!input || input.dataset.expiryFormatter === 'true') return;

  if (placeholder === false || placeholder === null) {
    input.removeAttribute('placeholder');
  } else {
    input.setAttribute('placeholder', placeholder);
  }
  input.setAttribute('inputmode', 'numeric');
  input.setAttribute('autocomplete', 'cc-exp');

  input.addEventListener('input', () => {
    input.value = formatCardExpiry(input.value);
  });

  input.addEventListener('blur', () => {
    input.value = formatCardExpiry(input.value, {
      expandYear: expandYearOnBlur,
      shortenYear: true,
    });

    const form = input.closest('form');
    const validator = form?.formTheme?.validator;
    if (validator) {
      validator.activated.add(input);
      validator.validate(input);
    }
  });

  if (input.value) {
    input.value = formatCardExpiry(input.value);
  }

  input.dataset.expiryFormatter = 'true';
}
